<template>
  <span>
    <el-button :class="isBzjz?'buttons':''" type="primary" @click="showList=true" style="margin-left: 10px">项目管理</el-button>
    <!--  列表弹窗  -->
    <el-dialog title="项目列表" :visible.sync="showList" width="800px" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false">
      <div>
        <div style="margin-bottom: 20px">
          <el-button :class="isBzjz?'checkbutton':''" type="primary" v-if="!isBzjz" @click="$refs.projectCount.show=true">查看项目记工统计</el-button>
          <el-button :class="isBzjz?'checkbutton':'checkbuttons'"  @click="$refs.projectEdit.open()">新增项目</el-button>
        </div>
        <el-table :data="list" border header-row-class-name="header" :cell-style="{height:'44px',padding:'0'}">
          <el-table-column prop="projectName" label="项目名称"/>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="$refs.projectEdit.open(scope.row)" style="color:#0286df">编辑</el-button>
              <el-button type="text" size="small" @click="del(scope.row)" style="color: #FF6600">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <page
          v-if="param.total&&!loading"
          :param="param"
          @change="getList(false)"
          :loadingTrue="loading"
        ></page>
      </div>
    </el-dialog>
    <delTips ref="delTips" @end="senddel"></delTips>
    <projectEdit ref="projectEdit" @editend="getList" :isBzjz=isBzjz></projectEdit>
    <projectCount ref="projectCount" @closeend="closeend"></projectCount>
  </span>
</template>

<script>
import {api} from '@/api/apiRecord.js'
export default {
  name: "projectManagement",
  components: {
    page: () => import("@/components/card/page"),
    delTips: () => import("./delTips"),
    projectEdit: () => import("./projectEdit"),
    projectCount: () => import("./projectCount"),
  },
  data(){
    return {
      showList:false,
      list:[],
      loading:false,
      param:{
        page:1,
        limit:10,
        total:0,
      },
      delform:{},
      type:this.$route.query.type?this.$route.query.type:1,//当前页面进入模式1.个人记工2.班组记工
    }
  },
  props:{
      isBzjz: {
      type: [Boolean],
      default: false
    }
  },
  watch:{
    showList(v){
      if(v)this.getList(false)
    }
  },
  methods:{
    //项目列表
    async getList(emit=true){
      this.loading=true;
      let res=await api.getProjectPage({...this.param,type:this.type});
      this.loading=false;
      if(res.data.code==200){
        this.list=res.data.data.records;
        this.param.total=res.data.data.total;
        if(emit)this.$emit('change')
      }
    },
    //删除项目
    del(data){
      this.$message.tips('删除该项目，会删除项目下的所有数据，确定删除该项目吗？',(v)=>{
        if(v){
          this.delform=data;
          this.$refs.delTips.show=true;
        }
      })
    },
    async senddel(data){
      data.no=this.delform.no;
      data.phoneNumber=this.$store.state.user.telPhone
      let res=await api.delTenderMoney(data);
      if(res.data.code==200){
        this.$message.success(res.data.msg);
        this.getList(true);
        this.$refs.delTips.erroinfo='';
        this.$refs.delTips.show=false;
      }else{
        if(res.data.msg.indexOf('开发')>-1)this.$message.kfz(res.data.msg)
        //else this.$message.error(res.data.msg)
        this.$refs.delTips.erroinfo=res.data.msg;
      }
    },
    closeend(no){
      this.showList=false;
      this.$emit('upNo',no)
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-dialog__header {
  border-bottom: 1px solid #e4e7ed;
  height: 44px;
  line-height: 44px;
  padding:0 20px!important;
}
/deep/.el-dialog__headerbtn {
    top: 12px;
}
/deep/.el-dialog__title {
  line-height: 44px;
  color: #000;
}
/deep/.checkbutton{
  color: #B79255 !important;
  background: #fff;
  border-color:#B79255 !important;
  height: 34px;
  line-height: 34px;
  padding: 0 15px;
  &:hover, &:focus{
  color: #B79255 !important;
  background: #fff;
  border-color:#B79255 !important;
  }
}
/deep/.buttons{
  color: #B79255 !important;
  background: #fff !important;
  border-color:#B79255 !important;
  height: 34px;
  line-height: 34px;
  padding: 0 15px;
  border-radius: 0;
}
/deep/.checkbuttons{
  color: #B79255 !important;
  background: #fff;
  border-color:#B79255 !important;
  &:hover, &:focus{
  color: #B79255 !important;
  background: #fff;
  border-color:#B79255 !important;
  }
}
/deep/.header .el-table__cell{
  background: #FAFAFA;
  padding: 0;
  height: 44px;
}
/deep/.el-dialog__body{
  padding: 20px;
}
/deep/.el-button--small{
  font-size: 14px;
}
  .el-button--primary {
    color: #fff;
    border-color: #B79255;
    background: #B79255;
    &:hover{
      color: #fff;
      border-color: #B79255;
      background: #B79255;

    }
  }
</style>
